import React from 'react'
import { Route } from 'react-router'
import * as Views from './views'

const Routes = <Route path="search" component={Views.Search} />

export default Routes
